import { render } from "./EnrollTINView.vue?vue&type=template&id=072443e6"
import script from "./EnrollTINView.vue?vue&type=script&lang=js"
export * from "./EnrollTINView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__